<section class="maintenance-page--top-section">
    <h1>Wegen Wartungsarbeiten ist das Serviceportal der VFA derzeit leider nicht verfügbar.</h1>
    <p>
        Aufgrund aktueller Wartungsarbeiten steht das Serviceportal der VFA vom {{ displayDate(maintenanceDate.maintenanceStartDate) }} Uhr bis zum
        {{ displayDate(maintenanceDate.maintenanceEndDate) }} Uhr nicht zur Verfügung.
    </p>
    <div class="maintenance-page--top-section__logout-button">
        <app-button
            [isButton]="true"
            buttonLabel="Abmelden"
            (clickEvent)="logoutUser()">
        </app-button>
    </div>
</section>
